import { isValidElement } from 'react';

function isReactElement(x) {
  return /*#__PURE__*/isValidElement(x) && x !== undefined;
}

export { isReactElement };
